import { render, staticRenderFns } from "./CompensationIcon.vue?vue&type=template&id=a38f43c6"
var script = {}


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports